import React from 'react';
import { graphql, useStaticQuery } from "gatsby"

import './JobsListing.scss';

const JobsListing = () => {

  const GreenhouseDepartmentsQuery = useStaticQuery(graphql`
    query GreenhouseQuery {
      greenhouseDepartments {
        greenhouseDepartments {
          departments {
            name
            jobs {
              id
              absolute_url
              title
              location {
                name
              }
            }
          }
        }
      }
    }
  `)

  let departments = GreenhouseDepartmentsQuery.greenhouseDepartments.greenhouseDepartments.departments.filter(department => department.jobs.length > 0);

  return (
    <>
      {departments.length > 0 && 
        <table className="JobsListingTable">
          <caption>Job listings at Okteto</caption>
          <thead>
            <tr>
              <th>Job Title</th>
              <th>Category</th>
              <th>Location</th>
            </tr>
          </thead>
          <tbody>
            {departments.map(department => (
              <>
                {department.jobs.map(job => (
                  <tr key={job.id}>
                    <td>
                      <a href={job.absolute_url}>{job.title}</a>
                    </td>
                    <td>
                      <span className="JobsListingTableSmallHeading">Category</span>
                      {department.name}
                    </td>
                    <td>
                      <span className="JobsListingTableSmallHeading">Location</span>
                      {job.location.name}
                    </td>
                  </tr>
                ))}
              </>
            ))}
          </tbody>
        </table>
      }
    </>
  );
};

export default JobsListing;
